import React, { useState } from 'react';
import { FilterIcon, ChevronUpIcon, ChevronDownIcon } from 'lucide-react';
import Button from './Button';
interface FilterPanelProps {
  title: string;
  onApplyFilters: () => void;
  onResetFilters: () => void;
  children: React.ReactNode;
}
const FilterPanel: React.FC<FilterPanelProps> = ({
  title,
  onApplyFilters,
  onResetFilters,
  children
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 transition-all duration-200 mb-6" data-id="element-169">
      <div className="px-5 py-4 border-b border-gray-200 flex items-center justify-between cursor-pointer" onClick={() => setIsCollapsed(!isCollapsed)} data-id="element-170">
        <div className="flex items-center" data-id="element-171">
          <FilterIcon className="h-5 w-5 text-blue-600 mr-2" data-id="element-172" />
          <h2 className="text-lg font-medium text-gray-800" data-id="element-173">{title}</h2>
        </div>
        <button className="text-gray-500 hover:text-gray-700 focus:outline-none" data-id="element-174">
          {isCollapsed ? <ChevronDownIcon className="h-5 w-5" data-id="element-175" /> : <ChevronUpIcon className="h-5 w-5" data-id="element-176" />}
        </button>
      </div>
      <div className={`transition-all duration-300 ease-in-out overflow-hidden ${isCollapsed ? 'max-h-0 opacity-0' : 'max-h-[1000px] opacity-100'}`} data-id="element-177">
        <div className="p-5" data-id="element-178">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-179">
            {children}
          </div>
          <div className="mt-5 flex justify-end space-x-3" data-id="element-180">
            <Button variant="outline" size="md" onClick={onResetFilters} data-id="element-181">
              Reset Filters
            </Button>
            <Button variant="primary" size="md" onClick={onApplyFilters} data-id="element-182">
              Apply Filters
            </Button>
          </div>
        </div>
      </div>
    </div>;
};
export default FilterPanel;